import once from "lodash/once";
import React from "react";
import FullBleedScreen from "./BeyondToolkit/FullBleedScreen";
import { IdeasCloseIcon } from "./IdeasIcons";

type ToolkitVideoPlayerProps = {
  onClose: VoidFunction;
  sendUsage: VoidFunction;
  videoSrc: string;
};

type ExtendedHTMLVideoElement = HTMLVideoElement & {
  mozRequestFullScreen: VoidFunction;
  requestFullScreen: VoidFunction;
  webkitRequestFullScreen: VoidFunction;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class ToolkitVideoPlayer extends React.Component<ToolkitVideoPlayerProps> {
  componentDidMount() {
    document.addEventListener("visibilitychange", this._onVisibilityChange);

    if (this.videoNode?.requestFullScreen) {
      this.videoNode.requestFullScreen();
    } else if (this.videoNode?.mozRequestFullScreen) {
      this.videoNode.mozRequestFullScreen();
    } else if (this.videoNode?.webkitRequestFullScreen) {
      this.videoNode.webkitRequestFullScreen();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this._onVisibilityChange);
  }

  render() {
    return (
      <FullBleedScreen>
        <div
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            padding: "dt_m",
            position: "relative",
          }}
        >
          <div sx={{ position: "absolute", left: "dt_m", top: "dt_m", zIndex: 10 }}>
            <IdeasCloseIcon onClick={() => this.props.onClose()} />
          </div>
          <video
            sx={{ width: "100%", height: "auto" }}
            controls
            autoPlay
            src={this.props.videoSrc}
            ref={(node: ExtendedHTMLVideoElement) => (this.videoNode = node)}
            onPlay={this._sendUsage}
            onEnded={() => this.props.onClose()}
          />
        </div>
      </FullBleedScreen>
    );
  }

  videoNode: ExtendedHTMLVideoElement | null;

  _onVisibilityChange = () => {
    if (document.hidden) {
      this.videoNode?.pause();
    }
  };

  _sendUsage = once(() => {
    this.props.sendUsage();
  });
}

export default ToolkitVideoPlayer;
